module.exports = __webpack_public_path__ + "static/img/line_logo_A.d5f8820.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/line_logo_A.svg
// module id = KKKM
// module chunks = 1